// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__33rKt","row":"styles_row__3u2tC"};